import styled from 'styled-components';
import InputMask, { Props } from 'react-input-mask';

const inputStyles = `
  width: 100%;
  height: 48px;
  padding: 0 16px;
  border: 1.5px solid #D9DDE3;
  border-radius: 10px;
  font-size: 15px;
  color: #18233A;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
  background: #fff;

  &:hover {
    border-color: #b0b5bd;
  }

  &::placeholder {
    color: #b0b5bd;
    font-weight: 400;
  }
`;

export const InputV2 = styled.input<{ color?: string }>`
  ${inputStyles}

  &:focus {
    border-color: ${(props) => props.color ?? '#00D95F'};
    box-shadow: 0 0 0 3px ${(props) => {
      const c = props.color ?? '#00D95F';
      return c + '1A';
    }};
  }
`;

export const SelectV2 = styled.select<{ color?: string }>`
  ${inputStyles}
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%236b7280' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 36px;

  &:focus {
    border-color: ${(props) => props.color ?? '#00D95F'};
    box-shadow: 0 0 0 3px ${(props) => {
      const c = props.color ?? '#00D95F';
      return c + '1A';
    }};
  }
`;

interface InputMaskProps extends Props {
  color?: string;
}

export const InputMaskV2 = styled(InputMask)<InputMaskProps>`
  ${inputStyles}

  &:focus {
    border-color: ${(props) => props.color ?? '#00D95F'};
    box-shadow: 0 0 0 3px ${(props) => {
      const c = props.color ?? '#00D95F';
      return c + '1A';
    }};
  }
`;
